


























import {
  Vue
} from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("password-validation", {
  data() {
    return {
      staticContent
    };
  },
  props: [
    'password'    
  ],
});
